import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setUserNotificationPreferences } from '../../../account/actions'
import PaidLeavePreferencesComponent from './paidLeavePreferencesComponent'

const mapDispatchToProps = (dispatch) => bindActionCreators(
  { setUserNotificationPreferencesDispatch: setUserNotificationPreferences },
  dispatch
)

const PaidLeavePreferencesConnect = connect(null, mapDispatchToProps)(PaidLeavePreferencesComponent)

export default PaidLeavePreferencesConnect
